import {createRouter, createWebHistory} from 'vue-router'
import Network from '../views/Network.vue'
import About from '../views/About.vue'
import Products from '../views/Products.vue'
import HomePage from '@/views/Home.vue'
import News from "@/views/News";

const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage
    },
    {
        path: '/network',
        name: 'Network',
        component: Network
    },
    {
        path: '/news',
        name: 'News',
        component: News,
    },
    {
        path: '/news/fec_news_detail',
        name: 'FecNewsDetail',
        component: () => import('@/views/news/fec_news_detail.vue')
    },
    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/products',
        name: 'Products',
        component: Products
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    // 自定义路由切换时的滚动行为
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            // 如果有哈希值，滚动到对应的锚点位置
            return {el: to.hash, behavior: 'smooth'};
        } else if (savedPosition) {
            // 如果有保存的位置（例如浏览器的前进/后退），恢复到该位置
            return savedPosition;
        } else {
            // 否则滚动到页面顶部
            return {top: 0};
        }
    }
})

export default router 